import { render } from "./App.vue?vue&type=template&id=7a7640ea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7a7640ea&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__